import { useConversation } from '@restaurant/api-client/react';
import { MessageSquare } from 'lucide-react';
import { useState } from 'react';
import { useParams } from 'react-router';
import { EmptyState } from '@/components/ui/misc';
import { cn } from '@/lib/utils';
import { ChatView } from './ChatView';
import { ConversationList } from './ConversationList';
import { CustomerPanel } from './CustomerPanel';

export function InboxPage() {
  const { conversationId } = useParams();
  const [panel, setPanel] = useState(() => window.innerWidth >= 1280);
  const { data: conversation } = useConversation(conversationId);

  return (
    <div className="flex h-full">
      <div className={cn('w-full shrink-0 border-r bg-card lg:w-80', conversationId && 'hidden lg:block')}>
        <ConversationList activeId={conversationId} />
      </div>
      <div className={cn('min-w-0 flex-1', !conversationId && 'hidden lg:block')}>
        {conversationId ? (
          <ChatView conversationId={conversationId} onTogglePanel={() => setPanel((p) => !p)} />
        ) : (
          <EmptyState icon={<MessageSquare />} title="Select a conversation" description="Choose a chat on the left to read and reply." />
        )}
      </div>
      {conversationId && conversation && panel ? (
        <div className="fixed inset-y-0 right-0 z-30 w-full max-w-sm border-l bg-card shadow-xl xl:static xl:w-80 xl:shadow-none">
          <CustomerPanel conversation={conversation} onClose={() => setPanel(false)} />
        </div>
      ) : null}
    </div>
  );
}
